import store from 'root/apps/pages/store';

import { isStatusConnected } from '../socketClient/types';

export const getCFDEnabled = () => {
  const { selectedDisplay, connection } = store.getState().hub;
  return !!Object.keys(selectedDisplay).length || isStatusConnected(connection.browserCFD);
};
